/* eslint-disable sonarjs/no-duplicate-string */

import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getActiveModal, getModalData, getFilterData, isFetching, getTimezone,
  getSelectedMenuItem,
} from '../../selectors/common';

import FilterW from '../../components/FilterW';

import {
  EVENT_STATUS_VALUES, EVENT_STATUS,
  BOOKING_TYPE,
  MODALS,
} from '../../constants';
import SelectableTable from '../../components/MenuItems/Events/SelectableTable';
import EventsModals from './EventsModals';
import EventsRow from './Soccer/EventsRow';
import TennisEventsRow from './Tennis/TennisEventsRow';
import BookingButton from './BookingButton';
import { aSetFilters, aSetOpenModal } from '../../reducers/common';
import { aSetSelectedRowMatchId } from '../../reducers/oddsHistory';

const mapToProps = (state) => ({
  filters: getFilterData(state),
  selectedMenuItem: getSelectedMenuItem(state),
  activeModal: getActiveModal(state),
  modalData: getModalData(state),
  isFetching: isFetching(state),
  getTimezone: getTimezone(state),

});

const actionsToProps = (dispatch) => ({
  setFilterData: (payload) => dispatch(aSetFilters(payload)),
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
  setSelectedRowMatchId: (payload) => dispatch(aSetSelectedRowMatchId(payload)),
});

class Events extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openedMenu: null,
      total: 0,
      numOfBooked: 0,
      bookingType: null,
    };
  }

  componentWillUnmount() {
    this.props.resetDetailsForEvents();
  }

  changePage=(event) => {
    this.setState({
      openedMenu: null,
    });

    this.props.setSelectedRowMatchId({
      selectedRowMatchId: event.matchId,
    });
  };

  bookUnbook=(event) => {
    this.setState({
      openedMenu: null,
    });
    if (event.bookedFlag) {
      this.props.unbookEvents({
        matchIds: [event.matchId],
      });
    } else {
      this.props.bookEvents({
        matchIds: [event.matchId],
      });
    }
    this.selectableTable.clearSelectedRows();
    this.onResetSelections();
  };

  bookUnbookEvents = (bookingType) => {
    this.setState({
      bookingType,
    });
    this.props.setOpenModal({ modal: MODALS.EVENT_SELECTION });
  };

  confirmBookings = () => {
    const matches = this.selectableTable.state.selectedRows.map((row) => this.props.events[row]);
    this.closeModal();
    if (this.state.bookingType === BOOKING_TYPE.BOOK) {
      const matchIds = matches.filter((event) => !event.bookedFlag
      && (event.status === EVENT_STATUS_VALUES.FUTURE
      || event.status === EVENT_STATUS_VALUES.PRE_MATCH)).map((match) => match.matchId);
      this.props.bookEvents({
        matchIds,
      });
    } else if (this.state.bookingType === BOOKING_TYPE.UNBOOK) {
      const matchIds = matches.filter((event) => event.bookedFlag
      && (event.status === EVENT_STATUS_VALUES.FUTURE
        || event.status === EVENT_STATUS_VALUES.PRE_MATCH)).map((match) => match.matchId);
      this.props.unbookEvents({
        matchIds,
      });
    }
    this.selectableTable.clearSelectedRows();
    this.onResetSelections();
  };

  openMenu=(event, e) => {
    e.preventDefault();
    if (this.selectableTable.state.selectedRows.length <= 1) {
      this.setState({
        openedMenu: this.state.openedMenu ? null : event.matchId,
      });
    }
  };

  onEventSelectionChange=(rows, event, isSelected, isReset) => {
    let { total, numOfBooked } = this.state;
    if (isReset) {
      total = 0;
      numOfBooked = 0;
    }
    if (event.status === EVENT_STATUS_VALUES.FUTURE
      || (event.status === EVENT_STATUS_VALUES.PRE_MATCH && this.props.isTennis)) {
      if (isSelected) {
        total += 1;
        numOfBooked = event.bookedFlag ? numOfBooked + 1 : numOfBooked;
      } else {
        total -= 1;
        numOfBooked = event.bookedFlag ? numOfBooked - 1 : numOfBooked;
      }
    }

    this.setState({
      total,
      numOfBooked,
      openedMenu: null,
    });
  };

  onResetSelections=() => {
    this.setState({
      total: 0,
      numOfBooked: 0,
      openedMenu: null,
    });
  };

  getClassName=(event) => (
    `table-style__row status--${EVENT_STATUS[event.status]} ${event.bookedFlag
      && 'table-style__row--booked'} ${this.state.openedMenu === event.matchId && 'open'}`
  );

  renderRow=(event, eventDate, eventTime) => (
    this.props.isTennis
      ? (
        <TennisEventsRow
          event={event}
          eventDate={eventDate}
          eventTime={eventTime}
          bookUnbook={this.bookUnbook}
          changePage={this.changePage}
        />
      )
      : (
        <EventsRow
          event={event}
          eventDate={eventDate}
          eventTime={eventTime}
          bookUnbook={this.bookUnbook}
          changePage={this.changePage}
          leagues={this.props.leagues}
        />
      )
  );

  /**
   * Close modal
   *
   * @function
   * @returns {void}
   */
  closeModal=() => {
    this.props.setOpenModal({ modal: '' });
  };

  loadMore = () => {
    this.props.getEvents(this.props.filters);
  };

  alignTimeHeadersWithTimezone = (events, timezone) => {
    const cache = {};

    return events.reduce((acc, curr) => {
      const dateWithTimezone = new Date(curr.startDateTime).toLocaleString('en-GB', { timeZone: timezone });
      const [dateString, time] = dateWithTimezone.split(', ');
      const [day, month] = dateString.split('/');
      const [hour] = time.split(':');
      const key = `${day}/${month}:${hour}`;

      if (cache[key]) {
        return acc;
      }
      
      cache[key] = key;
      return acc.concat(hour);
    }, []).map(hourString => parseInt(hourString));
  };

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    const numOfUnbooked = this.state.total - this.state.numOfBooked;
    const timeHeaders = this.props.getTimezone
      ? this.alignTimeHeadersWithTimezone(this.props.events, this.props.getTimezone) : null;

    return (
      <>
        <FilterW
          filterFields={this.props.filterFields}
          setFilterData={this.props.setFilterData}
          selectedItem={this.props.selectedItem}
          search={this.props.getEvents}
          filters={this.props.filtersParams}
          defaultFilter={this.props.defaultFilter}
          initialApiCall
          resetBeforeEachCall
          resetData={this.props.resetDetailsForEvents}
          legend
          resetChosenRows={this.onResetSelections}
          eventsPage
          dateFilterFields={this.props.filterFields[0]?.field}
          selectedTimezone={this.props.getTimezone}
          isTennis={this.props.isTennis}
          selectedMenuItem={this.props.selectedMenuItem}

        >
          <BookingButton
            id="bookBtn_EventsPage"
            onClick={this.bookUnbookEvents.bind(this, BOOKING_TYPE.BOOK)}
            number={numOfUnbooked}
            label="Book"
          />
          <BookingButton
            id="unbookBtn_EventsPage"
            onClick={this.bookUnbookEvents.bind(this, BOOKING_TYPE.UNBOOK)}
            number={this.state.numOfBooked}
            label="Unbook"
          />
        </FilterW>
        <SelectableTable
          loadMore={this.loadMore}
          isFetching={this.props.isFetching}
          ref={(r) => { this.selectableTable = r; }}
          openMenu={this.openMenu}
          renderRow={this.renderRow}
          getClassName={this.getClassName}
          onChange={this.onEventSelectionChange}
          onResetSelections={this.onResetSelections}
          rows={this.props.events}
          eventsTable
          timeHeaders={timeHeaders}
          headers={this.props.headers}
          lastDate={this.props.lastDate}
          lastEventId={this.props.lastEventId}
          timezone={this.props.getTimezone}
        />

        <div className={`modal ${this.props.activeModal ? 'modal--open' : ''}`}>
          <EventsModals
            activeModal={this.props.activeModal}
            selectableTable={this.selectableTable}
            events={this.props.events}
            bookingType={this.state.bookingType}
            closeModal={this.closeModal}
            confirmBookings={this.confirmBookings}
            isTennis={this.props.isTennis}
            leagues={this.props.leagues}
          />
        </div>

      </>

    );
  }
}

export default connect(mapToProps, actionsToProps)(Events);
